// extracted by mini-css-extract-plugin
module.exports = {"icon":"Bar_icon__p7U9b","tagAndViewAllResults":"Bar_tagAndViewAllResults__3jJqW","menu":"Bar_menu__nHkRy","suggestions":"Bar_suggestions__bZlWe"};